window.addEventListener('DOMContentLoaded', () => {
  // On click, redirect to the link's path with query params merged: any params already on the href
  // (e.g. GA linker _gl when cookies are declined) plus params from data-href-params (e.g.
  // referring_pro, referring_pro_gender, referring_pro_name). Merging into a single query string
  // avoids a double "?" when GTM has decorated the href. Server-rendered links use path-only hrefs
  // for SEO; params are added only on click.
  document.querySelectorAll('a[data-href-params]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const baseUrl = anchor.getAttribute('href');
      const url = new URL(baseUrl, window.location.origin);

      const ourParams = new URLSearchParams(anchor.getAttribute('data-href-params'));
      ourParams.forEach((value, key) => url.searchParams.set(key, value));

      event.preventDefault();
      window.location.href = `${url.pathname}?${url.searchParams.toString()}`;
    });
  });
});
